import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Image,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { resetUserDetails } from "../Redux/userSlice";
import { fetchChatHistory } from "../api/chatService";
import useCustomToast from "../customHooks/useCustomToast";
import { storeBrowserUUID } from "../utils/UTILITY_METHODS";

const Navbar = () => {
  const { firstName, lastName } = useSelector((store) => store.userDetails);
  const { isOpen, onToggle, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const token = localStorage.getItem("access_token");
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useCustomToast();

  useLayoutEffect(() => {
    const checkIfTokenIsExpired = async () => {
      try {
        await fetchChatHistory();
      } catch (error) {
        localStorage.clear();
        storeBrowserUUID();
      }
    };

    checkIfTokenIsExpired();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    storeBrowserUUID();
    onClose();
    navigate("/");
    dispatch(resetUserDetails());
    showToast("User logged out successfully", "success");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleHome = () => {
    navigate("/");
  };
  const currentPath = window.location.pathname;

  // Check if the current path is '/loan-officer'
  const isLoanOfficer = currentPath === "/loan-officer";
  return (
    <Box
      boxShadow="rgba(17, 17, 26, 0.05) 0px 0px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px"
      className="flex items-center justify-between p-4"
      backgroundColor="white"
      position="fixed"
      top={0}
      width="100%"
      zIndex={1000}
      height="74px"
    >
      <Link to={"/"}>
        <Box w={"15rem"} cursor={"pointer"}>
          {isLoanOfficer ? (
            <div className="text-2xl font-semibold ml-5">
              Axis National Bank
            </div>
          ) : (
            <Box w={"12rem"} cursor={"pointer"}>
              <Image src="./logo.svg" alt="Atlas Logo" />
            </Box>
          )}
        </Box>
      </Link>

      {token ? (
        <div className="flex gap-x-8 items-center mr-5">
          <Popover
            returnFocusOnClose={false}
            isOpen={isOpen}
            onClose={onClose}
            placement="bottom-start"
            closeOnBlur={true}
          >
            <PopoverTrigger>
              <Button mr={5} onClick={onToggle} variant="unstyled">
                <Avatar
                  color="white"
                  size="sm"
                  name={
                    firstName && lastName ? `${firstName} ${lastName}` : "Atlas"
                  }
                  bg="teal.500"
                  className="bg-orange-100 cursor-pointer font-semibold rounded-full"
                />
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <PopoverHeader fontWeight="semibold">Logout</PopoverHeader>
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverBody>Are you sure you want to log out?</PopoverBody>
              <PopoverFooter display="flex" justifyContent="flex-end">
                <ButtonGroup size="sm">
                  <Button variant="outline" onClick={onClose}>
                    Cancel
                  </Button>
                  <Button colorScheme="red" onClick={handleLogout}>
                    Logout
                  </Button>
                </ButtonGroup>
              </PopoverFooter>
            </PopoverContent>
          </Popover>
        </div>
      ) : (
        <Button
          colorScheme="teal"
          onClick={location.pathname === "/login" ? handleHome : handleLogin}
          backgroundColor="white"
          border="1px solid #E8E8E8" // Light border color
          color="teal.600" // Text color
          borderRadius="md" // Adjust border radius
          fontSize="lg"
          fontWeight="semibold"
          width="120px" // Fixed width
          px={4} // Padding adjustments
          py={2}
          _hover={{
            backgroundColor: "teal.50", // Slightly different background on hover
          }}
        >
          {location.pathname === "/login" ? "Home" : "Login"}
        </Button>
      )}
    </Box>
  );
};

export default Navbar;
